import {
  CREATE_PROJECT_REQUEST,
  CREATE_PROJECT_SUCCESS,
  CREATE_PROJECT_FAILURE,
  GET_PROJECT_REQUEST,
  GET_PROJECT_SUCCESS,
  GET_PROJECT_FAILURE,
  UPDATE_PROJECT_REQUEST,
  UPDATE_PROJECT_SUCCESS,
  UPDATE_PROJECT_FAILURE,
  RESET_PROJECT_STATE,
  PROJECT_LOADER_START,
  PROJECT_LOADER_STOP,
} from "./types";

export const startProjectLoader = () => ({
  type: PROJECT_LOADER_START,
});

export const stopProjectLoader = () => ({
  type: PROJECT_LOADER_STOP,
});

// Project Creation Actions
export const createProject = (projectData) => ({
  type: CREATE_PROJECT_REQUEST,
  payload: projectData,
});

export const createProjectSuccess = (response) => ({
  type: CREATE_PROJECT_SUCCESS,
  payload: response,
});

export const createProjectFailure = (error) => ({
  type: CREATE_PROJECT_FAILURE,
  payload: error,
});

// Get Project Actions
export const getProject = (projectId) => ({
  type: GET_PROJECT_REQUEST,
  payload: projectId,
});

export const getProjectSuccess = (projectData) => ({
  type: GET_PROJECT_SUCCESS,
  payload: projectData,
});

export const getProjectFailure = (error) => ({
  type: GET_PROJECT_FAILURE,
  payload: error,
});

// Update Project Actions
export const updateProject = (projectId, projectData) => ({
  type: UPDATE_PROJECT_REQUEST,
  payload: { projectId, projectData },
});

export const updateProjectSuccess = (response) => ({
  type: UPDATE_PROJECT_SUCCESS,
  payload: response,
});

export const updateProjectFailure = (error) => ({
  type: UPDATE_PROJECT_FAILURE,
  payload: error,
});

// Reset Project State
export const resetProjectState = () => ({
  type: RESET_PROJECT_STATE,
});
